import { useEffect, useState } from 'react'
import {
  Box,
  Button,
  ButtonGroup,
  Flex,
  Text,
  useToast
} from '@chakra-ui/react'
import { Alert, Spinner } from '../../../components/UI'
import {
  useNotificationPreferences,
  useUpdateNotificationPreferences
} from '../../../hooks/Users'
import {
  ADMIN_NOTIFICATION_MODES,
  getAdminNotificationMode
} from '../../../Utils/NotificationPreferences'

const NotificationPreferences = () => {
  const toast = useToast()
  const { data, isLoading, isError } = useNotificationPreferences()
  const {
    mutate,
    isLoading: isSaving,
    isError: isSaveError
  } = useUpdateNotificationPreferences()
  const confirmedMode = getAdminNotificationMode(data)
  const [selectedMode, setSelectedMode] = useState(confirmedMode)

  useEffect(() => {
    setSelectedMode(confirmedMode)
  }, [confirmedMode])

  const handleSave = () => {
    mutate(selectedMode, {
      onSuccess: () => {
        toast({
          title: 'Preferencias actualizadas',
          status: 'success',
          duration: 4000,
          isClosable: true,
          position: 'bottom-right'
        })
      },
      onError: () => {
        setSelectedMode(confirmedMode)
      }
    })
  }

  return (
    <Box borderTop={'1px solid'} borderColor={'gray.200'} mt={6} pt={5}>
      <Text color={'green.500'} fontWeight={700} fontSize={'lg'} mb={3}>
        Preferencias de notificaciones
      </Text>

      {isLoading ? (
        <Spinner size={'md'} show={true} />
      ) : (
        <Flex direction={'column'} align={'flex-start'} gap={4}>
          <ButtonGroup isAttached variant={'outline'}>
            <Button
              colorScheme={'green'}
              variant={
                selectedMode === ADMIN_NOTIFICATION_MODES.ALL
                  ? 'solid'
                  : 'outline'
              }
              aria-pressed={selectedMode === ADMIN_NOTIFICATION_MODES.ALL}
              onClick={() =>
                setSelectedMode(ADMIN_NOTIFICATION_MODES.ALL)
              }
            >
              Recibir todas
            </Button>
            <Button
              colorScheme={'green'}
              variant={
                selectedMode === ADMIN_NOTIFICATION_MODES.DIRECT_ONLY
                  ? 'solid'
                  : 'outline'
              }
              aria-pressed={
                selectedMode === ADMIN_NOTIFICATION_MODES.DIRECT_ONLY
              }
              onClick={() =>
                setSelectedMode(ADMIN_NOTIFICATION_MODES.DIRECT_ONLY)
              }
            >
              Solo las mías
            </Button>
          </ButtonGroup>

          <Button
            colorScheme={'green'}
            isLoading={isSaving}
            isDisabled={selectedMode === confirmedMode}
            onClick={handleSave}
          >
            Guardar
          </Button>
        </Flex>
      )}

      {(isError || isSaveError) && (
        <Box mt={4}>
          <Alert
            status={'error'}
            message={'No fue posible actualizar las preferencias'}
          />
        </Box>
      )}
    </Box>
  )
}

export default NotificationPreferences
